import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { APIErrorTrackEvent, moengageTrackEvent } from '../../../Analytics/moengageEventFunction';
import { useConfirmationModal } from '../../../Redux/context/modalContext';
import {
  supplierRegister,
  supplierSelfRegister,
  uploadRegistrationDocs,
} from '../../register/registerApi';
import { getCategories } from '../indexApi';

const useStoreData = () => {
  const history = useHistory();
  const CategoryData = [
    {
      label: 'Large Appliances',
      value: 1,
      subCategory: [
        { label: 'Television', value: 1 },
        { label: 'Refrigerator', value: 2 },
        { label: 'AC', value: 3 },
        { label: 'Washing Machine', value: 4 },
      ],
    },
    {
      label: 'Small Appliances',
      value: 2,
      subCategory: [
        { label: 'Owen', value: 1 },
        { label: 'Mixes', value: 2 },
        { label: 'Blender', value: 3 },
        { label: 'Toaster', value: 4 },
      ],
    },
    {
      label: 'Computer',
      value: 3,
      subCategory: [
        { label: 'Mac', value: 1 },
        { label: 'HP', value: 2 },
        { label: 'Asus', value: 3 },
        { label: 'Dell', value: 4 },
      ],
    },
    {
      label: 'Mobiles',
      value: 4,
      subCategory: [
        { label: 'Apple', value: 1 },
        { label: 'Samsung', value: 2 },
        { label: 'MI', value: 3 },
        { label: 'One Plus', value: 4 },
      ],
    },
  ];
  const [loading, setLoading] = useState(false);
  const [callbackLoading, setCallbackLoading] = useState(false);
  const [alertMsg, setAlertMsg] = useState({
    type: null,
    msg: null,
  });
  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState([]);

  const [categoryData, setCategoryData] = useState([]);

  const [storeCreated, setStoreCreated] = useState(false);

  const [selfRegisterForm, setSelfRegisterForm] = useState(false);

  const [businessDetailsShown, setBusinessDetailsShown] = useState(false);

  const [media, setMedia] = useState({});
  const [mediaArray, setMediaArray] = useState({});

  const [businessDetails, setBusinessDetails] = useState({
    ownerName: null,
    mobileNumber: null,
    city: null,
  });

  const [selfRegisterDetails, setSelfRegisterDetails] = useState({
    firmName: null,
    mobileNumber: null,
    emailId: null,
    ownerName: null,
    contactPersonName: null,
    address: null,
    pincode: null,
    city: null,
    state: null,
    bankAccountNumber: null,
    ifsc: null,
    pan: null,
    gst: null,
  });

  const { showModal, hideModal } = useConfirmationModal();

  const selectedSubCatagories = ((categoryData || []).find((c) => c.key == category) || {})
    .children;

  const selectCategory = (categoryKey) => {
    if (category === categoryKey) {
      setCategory(null);
    } else {
      setCategory(categoryKey);
    }
    setSubCategory([]);
  };

  const selectSubCategory = (subCategoryKey) => {
    if (subCategory.includes(subCategoryKey)) {
      setSubCategory(subCategory.filter((subCat) => subCat !== subCategoryKey));
    } else {
      setSubCategory([...subCategory, subCategoryKey]);
    }
  };

  const onContinueClick = () => {
    setBusinessDetailsShown(true);
  };

  const onChangeBusinessDetails = (e) => {
    const value = e?.target?.value;
    const name = e?.target?.name;

    if (name && (name === 'mobileNumber' ? value.length <= 10 : true)) {
      setBusinessDetails({
        ...businessDetails,
        [name]: value,
      });
      setSelfRegisterDetails({
        ...selfRegisterDetails,
        [name]: value,
      });
    }
  };

  const getCategoriesData = async () => {
    const data = await getCategories();
    if (data?.data?.categories) {
      setCategoryData(data?.data?.categories || []);
    }
  };

  const onSelfRegisterClick = () => {
    setStoreCreated(true);
  };

  const onRequestCallback = async () => {
    setCallbackLoading(true);

    const payload = {
      ...businessDetails,
      category: category,
    };

    const response = await supplierRegister(payload);

    setCallbackLoading(false);

    if (response?.data?.status === 'success') {
      showModal({
        message: 'Our Team will reach out to you in next 24 hours',
        handleConfirm: handleConfirm,
      });
      let moePrams = {
        ...businessDetails,
      };
      moengageTrackEvent('User_Registration_Callback', moePrams);
    } else {
      APIErrorTrackEvent({
        api: response?.data?.config?.url,
        apiPayLoad: JSON.stringify(payload),
        errorMsg: response?.data?.message,
      });
      alert(response?.data?.message);
    }
  };

  const handleConfirm = () => {
    hideModal();
    history.push('/login');
  };

  const toggleSelfRegisterForm = () => {
    setSelfRegisterForm(!selfRegisterForm);
  };

  const onSelfRegisterSubmit = async (data) => {
    if (!mediaArray?.panLink) {
      alert('Please Upload PAN Card');
    } else if (!mediaArray?.gstLink) {
      alert('Please Upload GST Certificate');
    } else if (!mediaArray?.cancelledChequeLink) {
      alert('Please Upload Cancelled Cheque');
    } else {
      setCallbackLoading(true);
      const formdata = {
        ...data,
        ...mediaArray,
        category: category,
        superCategory: subCategory,
        isEnquiry: false,
      };
      let createVenResponse = await supplierSelfRegister(formdata);
      setCallbackLoading(false);
      if (createVenResponse && createVenResponse.data) {
        if (createVenResponse.data.status === 'success') {
          let { emailId, mobileNumber, pincode, ownerName, firmName, city, category } = formdata;
          let moePrams = { emailId, mobileNumber, pincode, ownerName, firmName, city, category };
          setStoreCreated(true);
          moengageTrackEvent('User_Registration_Self_Register_Submission', moePrams);
        } else {
          APIErrorTrackEvent({
            api: createVenResponse?.data?.config?.url,
            apiPayLoad: JSON.stringify(formdata),
            errorMsg: createVenResponse?.data?.msg,
          });
        }
      }
    }
  };

  const onChangeSelfRegister = (e) => {
    const value = e?.target?.value;
    const name = e?.target?.name;

    setSelfRegisterDetails({
      ...selfRegisterDetails,
      [name]: value,
    });

    if (['ownerName', 'mobileNumber', 'city'].includes(name)) {
      setBusinessDetails({
        ...businessDetails,
        [name]: value,
      });
    }
  };

  const handleImage = (e, source) => {
    const { files } = e.target;
    if (files?.length > 0) {
      const formData = new FormData();
      formData.append('files', files[0]);
      uploadRegistrationDocs(formData)
        .then((res) => {
          if (res.data.status === 'success') {
            setMedia({ ...media, [source]: URL.createObjectURL(files[0]) });
            setMediaArray({ ...mediaArray, [source]: res.data.data });
          } else {
            alert(res.data.message);
          }
        })
        .catch((error) => {
          alert(error.response?.data?.message);
        });
    }
  };

  const removeImage = (imgType) => {
    if (imgType) {
      setMedia({ ...media, [imgType]: null });
      setMediaArray({ ...mediaArray, [imgType]: null });
    }
  };

  return {
    selectCategory,
    category,
    selectSubCategory,
    subCategory,
    selectedSubCatagories,
    onContinueClick,
    businessDetailsShown,
    onChangeBusinessDetails,
    businessDetails,
    getCategoriesData,
    categoryData,
    storeCreated,
    onSelfRegisterClick,
    onRequestCallback,
    callbackLoading,
    toggleSelfRegisterForm,
    selfRegisterForm,
    selfRegisterDetails,
    onSelfRegisterSubmit,
    onChangeSelfRegister,
    handleImage,
    removeImage,
    media,
  };
};

export default useStoreData;
